import React from 'react'
import * as Yup from 'yup'
import { notification } from 'antd'
import {
  ButtonField,
  CustomFormComponent,
  InputFieldSection,
  PanelForm,
  SubmitSection,
} from '../../../../components/panels/content'
import webhooksLogo from '../../../../assets/png/webhooks.png'
import { IntegrationSection } from '../../../../components/integrations/integration-sections'

export const EventsWebhookIntegration = ({
  isActivated,
  toggleEventsWebhook,
  setEventsWebhookSettings,
  isTestInProgress,
  webhookURL,
  secret,
  onTestClicked,
}) => {
  return (
    <IntegrationSection
      enabled={isActivated}
      onEnableToggle={({ events_webhook_integrations_checkbox }) =>
        toggleEventsWebhook(events_webhook_integrations_checkbox)
      }
      integrationName="events_webhook"
      headerLogo={webhooksLogo}
      headerTitle="Events Webhook Integration"
      sectionTitle=""
      sectionDescription="Integrate Spectral with your custom events webhook to receive notifications on state changes within your account"
      sectionRenderedContent={null}
    >
      <PanelForm
        onSubmit={setEventsWebhookSettings}
        initialValues={{
          webhookURL,
          secret,
        }}
        validationSchema={Yup.object({
          webhookURL: Yup.string()
            .url('Must be a valid URL')
            .required('Required'),
          secret: Yup.string().required('Required'),
        })}
      >
        <InputFieldSection
          name="webhookURL"
          label="URL"
          description="The url to send notifications to"
          placeholder="https://my.domain.com/spectral/reciever"
          required
          merge
        />
        <InputFieldSection
          name="secret"
          label="Signature token"
          description="Required to verify the message integrity on the receiving side"
          placeholder="3e257e57bc674b94bac10b1a4bda41e7"
          required
          merge
        />
        <CustomFormComponent>
          {(
            _setFieldValue,
            _setFieldTouched,
            _validateForm,
            values,
            isValid
          ) => (
            <ButtonField
              disabled={!isValid}
              loading={isTestInProgress}
              description="We'll send an example event to your webhook"
              onClick={async () => {
                const { isTestSuccessful, message } = await onTestClicked({
                  webhookURL: values.webhookURL,
                  secret: values.secret,
                })
                if (isTestSuccessful) {
                  notification.success({
                    message: 'Success!',
                    description: message,
                  })
                } else {
                  notification.error({
                    message: 'Failed',
                    description: message,
                  })
                }
              }}
              name="test"
              label="Test"
            />
          )}
        </CustomFormComponent>
        <SubmitSection text="Update" />
      </PanelForm>
    </IntegrationSection>
  )
}
